import {Repository} from '@s-ui/domain'

/**
 * @interface
 */
export class LastCallRepository extends Repository {
  showLastCall() {
    throw new Error('[LastCallRepository#showLastCall] must be implemented')
  }

  createLastCall() {
    throw new Error('[LastCallRepository#createLastCall] must be implemented')
  }
}
